export * from './ecall-summary.component';
export * from './ecall-summary.service';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/ecall/ecall-summary/index.ts